<section class="py-3">
  <div class="container-fluid card card-div d-flex flex-column">
    <div class="flex-shrink-0 sticky-header">
      <div class="row d-flex justify-content-between align-items-center g-3 mb-4">
        <div class="col-12 col-md-6 sku-ledger-widget d-flex flex-column align-items-start">
          <div class="sku-badge px-3 px-md-4 py-2 mb-2 d-inline-block">
            <h2 class="sku-name fw-bold m-0 text-break">Expense Categories</h2>
          </div>
        </div>

        <div class="col-12 col-md-6 d-flex align-items-center gap-2 justify-content-md-end flex-wrap">
          <div class="search-wrapper position-relative" style="width: 220px;">
            <input
              type="text"
              class="form-control search-input"
              placeholder="Search category..."
              style="border-radius: 8px; padding-left: 35px; height: 38px; border: 1.5px solid #E2E8F0; font-size: 13px;"
              #searchVal
              (input)="changeCatInput(searchVal.value)">
              <fa-icon [icon]="faSearch" class="position-absolute start-0 top-50 translate-middle-y ms-3 text-muted" style="pointer-events: none; font-size: 13px;"></fa-icon>
            </div>
            @if (isCompanyUser) {
              <button class="btn add-btn" (click)="openAddModal(categoryPanel)">
                <fa-icon [icon]="faPlus" class="me-1"></fa-icon>
                <span class="fw-bold small">Add Category</span>
              </button>
            }
          </div>
        </div>
      </div>

      <div class="flex-grow-1" style="min-height: 0;">
        <div class="card rounded-4 thick-border-gray shadow-none h-100">
          <div class="table-responsive h-100" infiniteScroll [scrollWindow]="false" [infiniteScrollDistance]="2"
            [infiniteScrollThrottle]="500" (scrolled)="onscrollTable()">
            <table class="table custom-table align-middle m-0">
              <thead>
                <tr>
                  <th>Category</th>
                  <th>Expense</th>
                  <th>Status</th>
                  @if (isCompanyUser) {
                    <th class="text-center">Actions</th>
                  }
                </tr>
              </thead>
              <tbody>
                @for (exp of expanseList; track exp; let i = $index) {
                  <tr class="normal-row">
                    <td>
                      <span class="name-badge rounded-pill" [ngStyle]="getBadgeStyle(exp)">{{ exp.name }}</span>
                    </td>
                    <td class="table-text-one">{{ exp.count || 0 }}</td>
                    <td class="table-text-one">
                      <span [ngClass]="exp.status == 'Active' ? 'text-green fw-bold' : 'text-red'">
                        {{ exp.status }}
                      </span>
                    </td>
                    @if (isCompanyUser) {
                      <td class="text-center">
                        <button class="btn btn-sm btn-edit"
                          (click)="editExpense(exp, categoryPanel)"
                          title="Edit">
                          <fa-icon [icon]="faEdit"></fa-icon>
                        </button>
                      </td>
                    }
                  </tr>
                }
                <!-- Loader row -->
                @if (loader) {
                  <tr>
                    <td [attr.colspan]="isCompanyUser ? 4 : 3" class="text-center py-4">
                      <app-loader [loadingIcon]="loader"></app-loader>
                    </td>
                  </tr>
                }
                <!-- Error row -->
                @if (!loader && errorMessage) {
                  <tr>
                    <td [attr.colspan]="isCompanyUser ? 4 : 3" class="text-center py-4">
                      <span class="text-red small fw-semibold">{{ errorMessage }}</span>
                    </td>
                  </tr>
                }
                <!-- Empty row -->
                @if (!loader && !errorMessage && expanseList.length === 0) {
                  <tr>
                    <td [attr.colspan]="isCompanyUser ? 4 : 3" class="text-center py-4 text-muted small">
                      No categories found.
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Category Offcanvas Panel -->
  <ng-template #categoryPanel let-offcanvas>
    <div class="panel-wrapper d-flex flex-column h-100">

      <!-- Sticky Header -->
      <div class="panel-header flex-shrink-0">
        <h4 class="panel-title fw-bold m-0">{{ isEditMode ? 'Edit Category' : 'Add Category' }}</h4>
        <button type="button" class="panel-close-btn" (click)="closePanel()" [disabled]="modalLoader">
          &#x2715;
        </button>
      </div>

      <!-- Scrollable Body -->
      <div class="panel-body flex-grow-1 overflow-auto">
        <!-- Category Name -->
        <div class="mb-4">
          <label class="panel-field-label" for="categoryNameInput">Category name *</label>
          <input
            id="categoryNameInput"
            type="text"
            class="panel-input"
            placeholder="e.g. FUEL, RENT"
            [ngModel]="modalCategoryName"
            (ngModelChange)="modalCategoryName = $event.toUpperCase().trim()"
            [disabled]="modalLoader">
          </div>

          <!-- Active Toggle -->
          <div class="d-flex justify-content-between align-items-center">
            <span class="panel-toggle-label">Active</span>
            <div class="form-check form-switch m-0">
              <input class="form-check-input panel-toggle" type="checkbox"
                [(ngModel)]="modalIsActive"
                [disabled]="modalLoader">
              </div>
            </div>

            <!-- Error Message -->
            @if (modalErrorMessage) {
              <div class="alert alert-danger py-2 mt-4 mb-0 small">
                {{ modalErrorMessage }}
              </div>
            }
          </div>

          <!-- Sticky Footer -->
          <div class="panel-footer flex-shrink-0 d-flex gap-3">
            <button class="btn panel-cancel-btn flex-fill" (click)="closePanel()" [disabled]="modalLoader">
              Cancel
            </button>
            <button class="btn panel-save-btn flex-fill" (click)="onSave()"
              [disabled]="modalLoader || !modalCategoryName.trim()">
              @if (modalLoader) {
                <fa-icon [icon]="faSpinner" [animation]="'spin'" class="me-1"></fa-icon>
              }
              {{ isEditMode ? 'Update Category' : 'Add Category' }}
            </button>
          </div>
        </div>
      </ng-template>
